exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ui.form{margin-bottom:1rem}.ui.form textarea{font-size:1.5rem;resize:none}.ui.primary.button{margin:10px 0}a.ui.button{margin-right:13px;margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/頁/查/查.css
// module id = 505
// module chunks = 0